<template>
  <div class="request-draw-action">
    <!-- Request Draw button -->
    <button
      v-if="
        !showRequestDrawConfirm && !showResponseDrawConfirm && !showResponseDraw
      "
      :disabled="!canRequestDraw"
      class="button is-link is-outlined"
      @click="showRequestDrawConfirm = true"
    >
      Request Draw
    </button>

    <!-- Request Draw Confirmation -->
    <div v-if="showRequestDrawConfirm" class="confirm-button">
      <div class="button is-static is-link is-light">Request Draw</div>
      <button
        class="button is-link is-outlined"
        @click="
          () => {
            showRequestDrawConfirm = false;
            this.$emit('onRequestDraw');
          }
        "
      >
        ½
      </button>
      <button
        class="button is-outlined"
        @click="showRequestDrawConfirm = false"
      >
        <span class="icon is-large">
          <i class="fa fa-times"></i>
        </span>
      </button>
    </div>

    <!-- Response Draw Confirmation -->
    <div v-if="showResponseDrawConfirm" class="confirm-button">
      <div class="button is-static is-link is-light">Accept Draw?</div>
      <button
        class="button is-link is-outlined"
        @click="
          () => {
            showResponseDrawConfirm = false;
            this.$emit('onAcceptDraw');
          }
        "
      >
        ½
      </button>
      <button
        class="button is-outlined"
        @click="
          () => {
            showResponseDrawConfirm = false;
            this.$emit('onDenyDraw');
          }
        "
      >
        <span class="icon is-large">
          <i class="fa fa-times"></i>
        </span>
      </button>
    </div>

    <!-- Response Draw -->
    <div v-if="showResponseDraw">
      <div class="button is-static is-link is-light">
        {{ drawResponse }}
      </div>
    </div>
  </div>
</template>

<script>
const notifyAudio = new Audio(
  "https://images.chesscomfiles.com/chess-themes/sounds/_MP3_/default/notify.mp3"
);

export default {
  name: "RequestDraw",

  props: ["match", "move", "playerColor"],

  data() {
    return {
      canRequestDraw: false,
      showRequestDrawConfirm: false,
      showResignConfirm: false,
      showResponseDrawConfirm: false,
      showResponseDraw: false,
    };
  },

  computed: {
    drawResponse() {
      if (!this.move) return "";

      const { userAction } = this.move;

      if (!userAction) return "";

      if (!userAction.drawRequestedAt) return "";

      if (!userAction.drawResponse) return "Draw Requested";

      if (userAction.drawResponse === "accept") {
        return "Draw accepted";
      } else if (userAction.drawResponse === "deny") {
        return "Draw denied";
      }
      return "";
    },
  },

  watch: {
    move: {
      handler() {
        if (!this.move) {
          return;
        }

        const { userAction } = this.move;

        this.canRequestDraw =
          this.match &&
          !this.match.result &&
          (!userAction || !userAction.drawRequestedAt);

        this.showRequestDrawConfirm = false;
        this.showResponseDrawConfirm =
          userAction &&
          userAction.drawRequestedAt &&
          !userAction.drawResponse &&
          userAction.drawRequestedByColor !== this.playerColor;

        this.showResponseDraw =
          userAction &&
          (userAction.drawResponse ||
            userAction.drawRequestedByColor === this.playerColor);

        if (
          this.showRequestDrawConfirm ||
          this.showResponseDrawConfirm ||
          this.showResponseDraw
        ) {
          notifyAudio.play();
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style scoped>
.confirm-button {
  transition: 1850ms ease-in-out;
}
</style>
